// Runmode コンポーネントMixins
import { mapGetters } from "vuex";
import common from "@/mixin/common";
import audio from "@/mixin/audio";
import lodash from "lodash";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

export default {
  props: {
    pathstep: Object
  },
  data() {
    return {
      // オーディオオブジェクト
      audioContext: null,
      audioPlaying: false,
      // 現在のact
      currentAct: null,
      // 現在のactのindex
      currentActIndex: 0,
      // 音声リプレイフラグ
      isAudioReplay: false,
      // 音声リプレイ可能フラグ
      enableAudioReplay: false,
      // タイマー処理変数
      timer: null,
      myAudio: null,
      // 正解音
      myAudioCollect: null,
      // 不正解音
      myAudioIncollect: null,
      // 不正解画像表示時間
      incorrectImageDuration: 1000,
      // Runmode用swiper外側
      swiperOut: null,
      // Runmode用swiper内側
      swiperIn: null,
      // 画面表示済みフラグ
      isAutoAdjustShown: false,
      // 英語自動調整設定
      usTopAreaHeight: 0,
      usTopAreaFontSize: 0,
      usCardAreaHeight: 0,
      usCardAreaFontSize: 0,
      // 日本語自動調整設定
      jpTopAreaHeight: 0,
      jpTopAreaFontSize: 0,
      jpCardAreaHeight: 0,
      jpCardAreaFontSize: 0,
      // プレースホルダーフォントサイズ
      placeholderFontSize: 0
    };
  },
  mixins: [
    common,
    audio
  ],
  mounted() {
    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1) {
      this.fixtHeightForSafariFullWindow();
    }

    if (this.pathstep != null) {
      this.common_init();
    }

    const MAX_AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
    this.usTopAreaFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
    this.usCardAreaFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
    this.jpTopAreaFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
    this.jpCardAreaFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
    this.placeholderFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
  },
  beforeDestroy: function() {
    this.destroyRunmode();
  },
  computed: {
    ...mapGetters([
      "lessonState",
      "showPinchIn",
      "textSize"
    ]),
    dispJapaneseStatus: function() {
      return this.$store.getters.showJapanese;
    },
    dispAllAnswerStatus: function() {
      return this.$store.getters.showAllAnswer;
    },
    answerSoundMute: function() {
      // 解答音ミュートフラグ
      return this.$store.getters.answerSound == "true" ? false : true;
    },
    cssLayoutID: function() {
      return "layout" + this.pathstep.layoutID;
    },
    placeholderStyles: function() {
      return {
        "--placeholderFontSizePx": String(this.placeholderFontSize) + "px",
        "--placeholderFontSizeRem": String(this.placeholderFontSize / 10) + "rem"
      }
    }
  },
  methods: {
    /**
     * 共通初期化処理
     */
    common_init: function() {
      // オーディオ初期化
      this.myAudio = new Audio();
      this.myAudioCollect = new Audio(mixinConstants.AUDIO_CORRECT);
      this.myAudioIncollect = new Audio(mixinConstants.AUDIO_INCORRECT);
      // オーディオロード
      this.myAudioCollect.load();
      this.myAudioIncollect.load();
      this.currentAct = this.pathstep.acts[this.currentActIndex];
      const self = this;
      this.myAudio.onended = function() {
        // 再生終了時処理
        self.audioPlaying = false;
        self.audioEnded();
      };
    },
    /**
     * Runmode破棄時の処理
     */
    destroyRunmode: function() {
      clearTimeout(this.timer);

      if (this.myAudio != null) {
        this.myAudio.pause();
        this.myAudio = null;
      }

      if (this.myAudioCollect != null) {
        this.myAudioCollect.pause();
        this.myAudioCollect = null;
      }

      if (this.myAudioIncollect != null) {
        this.myAudioIncollect.pause();
        this.myAudioIncollect = null;
      }
    },
    /**
     * 次のactへ
     */
    setNextAct: function(func) {
      if (this.currentActIndex < this.pathstep.acts.length - 1) {
        // 次のアクトへ
        this.currentActIndex++;
        this.currentAct = this.pathstep.acts[this.currentActIndex];
        if (func) {
          this.$nextTick(func);
        }
        return true;
      } else {
        // 結果表示処理
        return false;
      }
    },
    getShuffleActs: function() {
      // shuffle
      var acts = JSON.parse(JSON.stringify(this.pathstep.acts));
      var j, x, i;
      for (i = acts.length; i; i -= 1) {
        j = Math.floor(Math.random() * i);
        x = acts[i - 1];
        acts[i - 1] = acts[j];
        acts[j] = x;
      }
      return acts;
    },
    /**
     * 音声再生
     */
    audioPlay: function(audioPath) {
      if (this.audioPlaying) {
        // 再生中は何もしない
        return;
      }
      if (!this.myAudio.paused) {
        this.myAudio.pause();
      }
      this.audioPlaying = true;
      this.myAudio.src = audioPath;
      this.myAudio.play();
    },
    /**
     * 自動再生
     */
    autoPlay: function(audioPath, duration) {
      this.isAudioReplay = false;
      duration = duration === undefined ? 2000 : duration;
      const self = this;
      this.timer = setTimeout(function() {
        self.audioPlay(audioPath);
      }, duration);
    },
    /**
     * 音声リプレイ
     */
    audioReplay: function(audioPath) {
      if (this.enableAudioReplay) {
        this.isAudioReplay = true;
        this.audioPlay(audioPath);
      }
    },
    // 正解音
    audioAnswerCollect: function() {
      // 解答音ミュート
      this.myAudioCollect.muted = this.answerSoundMute;
      this.myAudioCollect.pause();
      this.myAudioCollect.play();
    },
    // 不正解音
    audioAnswerIncorrect: function() {
      // 解答音ミュート
      this.myAudioIncollect.muted = this.answerSoundMute;
      this.myAudioIncollect.pause();
      this.myAudioIncollect.play();
    },
    /**
     * 選択中のACTクラス
     */
    classActActive: function(index) {
      if (index === this.currentActIndex) {
        return { active: true };
      } else {
        return { active: false };
      }
    },
    /**
     * テキストフォントサイズ取得
     */
    getTextFontSize: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 25) {
        return "font28";
      } else if (textLength <= 35) {
        return "font24";
      } else if (textLength <= 60) {
        return "font21";
      } else if (textLength <= 75) {
        return "font18";
      } else if (textLength <= 85) {
        return "font15";
      } else if (textLength <= 124) {
        return "font13";
      } else {
        return "font11";
      }
    },
    /**
     * 日本語テキストフォントサイズ取得
     */
    getTextFontSizeJP: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 12) {
        return "font28";
      } else if (textLength <= 16) {
        return "font24";
      } else if (textLength <= 19) {
        return "font21";
      } else if (textLength <= 32) {
        return "font18";
      } else if (textLength <= 40) {
        return "font15";
      } else if (textLength <= 60) {
        return "font13";
      } else {
        return "font11";
      }
    },
    setAudioEnded: function(func) {
      // 音声再生終了イベント処理セット
      if (func) {
        this.myAudio.onended = func;
      }
    },
    imageBackgroundStyle: function(img_path) {
      // 背景画像のスタイル取得
      return {
        "background-image": "url(" + img_path + ")"
      };
    },
    audioEnded: function() {
      this.log("audio endid");
    },
    /**
     * 全問正解チェック
     * pathstep内のchallengeのact全て正解したかを判定する
     *
     * @param correctIndexLength 正解した問題の数
     * @return 全問正解の場合はtrue、それ以外はfalse
     */
    isAllCorrect: function(correctIndexLength) {
      this.log("runmode start isAllCorrect");
      if (correctIndexLength == this.getQuestionCount()) {
        return true;
      }
      return false;
    },
    /**
     * 対象act解答有無チェック
     * 対象actがgiven（解答なし）かchallenge（解答あり）かを判定する
     *
     * @param act チェック対象のact
     * @return challengeはture、givenはfalse
     */
    isChallenge: function(act) {
      this.log("runmode start isChallenge");
      if (act.challenge == 0) {
        return false;
      }
      return true;
    },
    /**
     * 画像シャッフルチェック
     * pathstep内のactのindex配列を取得し、返却する。
     * シャッフルする設定の場合は、actのindex配列をシャッフルして返却し、
     * グループありの場合は一律シャッフルしない
     *
     * @param なし
     * @return items actのindex配列
     */
    getShuffleItems: function() {
      this.log("runmode start getShuffleItems");
      var items = this.getItems();

      if (this.pathstep.scramble == true) {
        if (this.pathstep.groupNum == 0) {
          // グループなしの場合
          return _.shuffle(items);
        }
      }
      return items;
    },
    /**
     * 出題問題取得
     * 未出題かつ、pathstep内の先頭のactを取得する
     *
     * @param currentIndex 出題済みのactのindex配列
     * @return questionAct 出題対象のact
     *
     */
    getQuestion(currentIndex) {
      this.log("runmode start getQuestion");

      var questionAct = null;

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        // 既に出題済みかを判定する
        if (currentIndex.indexOf(i) == -1) {
          questionAct = this.pathstep.acts[i];
          break;
        }
      }

      return questionAct;
    },
    /**
     * pathstep内のgivenのactを全て取得し、返却する。
     *
     * @param なし
     * @return givenActs givenのact配列
     *
     */
    getGivenQuestion: function() {
      this.log("runmode start getGivenQuestion");

      var givenActs = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (!this.isChallenge(this.pathstep.acts[i])) {
          givenActs.push(this.pathstep.acts[i]);
        }
      }
      return givenActs;
    },
    /**
     * 出題問題取得_ランダム
     * challengeかつ、未出題の問題をランダムで取得し、返却する
     *
     * @param correctIndex 出題済みactのindex配列
     * @return questionAct 出題対象のact
     */
    getQuestionRandom: function(correctIndex) {
      this.log("runmode start getQuestionRandom");

      var questionActs = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        // 既に出題済みかを判定する
        if (correctIndex.indexOf(i) == -1) {
          if (this.isChallenge(this.pathstep.acts[i])) {
            questionActs.push(this.pathstep.acts[i]);
          }
        }
      }

      if (questionActs.length == 0) {
        return null;
      }
      var random = Math.floor(Math.random() * questionActs.length);
      return questionActs[random];
    },
    /**
     * 解答act数取得
     * pathstep内のchallengeのact数を返却する
     *
     * @param なし
     * @return QuestionCount challengeのact数
     */
    getQuestionCount: function() {
      this.log("runmode start getQuestionCount");
      var QuestionCount = 0;
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (!this.pathstep.acts[i].challenge == 0) {
          QuestionCount += 1;
        }
      }
      return QuestionCount;
    },
    /**
     * pathstep内のactのindex配列を取得し、返却する
     *
     *
     * @param なし
     * @return items actのindex配列
     */
    getItems: function() {
      this.log("runmode start getItems");

      var items = [];
      if (this.pathstep.groupNum != 0) {
        // グループありの場合
        for (var i = 1; i <= this.pathstep.groupNum; i++) {
          var groupItems = [];
          for (var j = 0; j < this.pathstep.acts.length; j++) {
            if (this.pathstep.acts[j].group == i) {
              groupItems.push(j);
            }
          }
          items.push(groupItems);
        }
        return items;
      } else {
        // グループなしの場合
        for (var i = 0; i < this.pathstep.acts.length; i++) {
          items.push(i);
        }
        return items;
      }
      return items;
    },
    /**
     * 解答用テキストの取得
     * 正解のテキストを含む解答用のact配列を取得する（最大３件）
     * Runmode:A1Q,NR系(NR1,NR2,NR3,NR3_NT)での使用を想定
     *
     * @param correctText 正解となるテキスト
     * @return answerActs 解答用のact配列
     */
    getAnswers: function(correctText) {
      this.log("runmode start getAnswers");

      // 返却値
      var answerActs = [];
      // 退避用のact配列
      var tmpAnswerActs = [];
      // 取得済みのactのIndex配列
      var alreadyGetIndex = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          // challengeのactを全てを取得する
          tmpAnswerActs.push(this.pathstep.acts[i]);
        }
      }

      if (tmpAnswerActs.length >= 3) {
        // challengeのactが３件以上の場合は、３件に絞る
        for (var i = 0; i < tmpAnswerActs.length; i++) {
          if (tmpAnswerActs[i].basicText == correctText) {
            // 正解となるテキストを取得する
            answerActs.push(tmpAnswerActs[i]);
            alreadyGetIndex.push(i);
            break;
          }
        }

        for (var i = 0; i < 2; i++) {
          // 残り２件のテキストをランダム取得する
          var random = Math.floor(Math.random() * tmpAnswerActs.length);

          while (alreadyGetIndex.indexOf(random) != -1) {
            // 既に取得済みの場合は、取得対象から除外する
            random = Math.floor(Math.random() * tmpAnswerActs.length);
          }
          answerActs.push(tmpAnswerActs[random]);
          alreadyGetIndex.push(random);
        }
      } else {
        answerActs = tmpAnswerActs;
      }

      return _.shuffle(answerActs);
    },
    /**
     * レイアウトＩＤ毎に適用するクラスを切り替える
     * グループなしの場合は、上段／下段で適用するクラス名が返却され、
     * グループありの場合は、各グループ毎に適用するクラス名が返却される。
     *
     * @param なし
     * @return TemplateTypes 適用するクラス名の配列
     */
    getTemplateTypes: function() {
      switch (this.pathstep.layoutID) {
        case 1:
        case 20:
        case 55:
          return ["card-col3s"];
        case 2:
          if(this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col2s", "card-col2s"];
          }
          return ["card-col4s"];
        case 21:
        case 31:
          return ["card-col2s", "card-col2s"];
        case 3:
          if(this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col3s", "card-col2s"];
          }
          return ["card-col5s"];
        case 34:
        case 38:
          return ["card-col3s", "card-col2s"];
        case 4:
          if(this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col3s", "card-col3s"];
          }
          return ["card-col6s"];
        case 33:
        case 35:
          return ["card-col3s", "card-col3s"];
        case 6:
          if (this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col2p full", "card-col2p full"];
          }
          return ["card-col4p"];
        case 5:
          if(this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col2p", "card-col2p", "card-col2p"];
          }
          return ["card-col6p"];
        case 7:
        case 51:
        case 57:
          return ["card-col2p", "card-col2p", "card-col2p"];
        case 28:
        case 36:
          return ["card-col2p", "card-col2p"];
        case 29:
        case 37:
          return ["card-col3p", "card-col2p"];
        case 8:
          return ["card-col3p2r"];
        case 9:
          return ["card-col2p2r"];
        case 30:
          return ["card-col3p", "card-col3p-after1s"];
        case 32:
          if(this.isEnvironmentPc() || this.pathstep.mode == mixinConstants.RUNMODE_A1Q) {
            return ["card-col3p", "card-col3p"];
          }
          return ["card-col6p"];
        case 56:
          return ["card-col3p", "card-col3p"];
        default:
          return "";
      }
    },
    /**
     * 問題解答時のステータスを設定する
     *
     * @param state 正解の場合はtrue、不正解の場合はfalse
     * @return なし
     */
    setActState: function(state) {
      this.log("runmode start setActState");

      if (state == true) {
        this.$store.dispatch("setCurrentPathstep", constants.ACT_STATE_OK);
      } else {
        this.$store.dispatch("setCurrentPathstep", constants.ACT_STATE_NG);
      }
    },
    /**
     * 音声再生後、次の音声を再生する／全問正解後、次の問題を出題する等、一定の間隔を空けたい場合に使用する
     * 呼び出し元は返値のPromiseが成功（resolve）した後に次の処理を実行するよう設定する
     *
     * @param time 間隔を空けるミリ秒を設定する（/src/mixin/constants.jsの処理間隔を設定する）
     * @return Promise
     */
    setInterval: function(time) {
      this.log("runmode start questionInterval");

      return new Promise(function(resolve, reject) {
        setTimeout(function() {
          resolve();
        }, time);
      });
    },
    /**
     * 音声停止処理
     */
    runmodeAudioPause: function() {
      this.log("runmode start audioPause");

      if (this.myAudio != null && !this.myAudio.paused) {
        this.myAudio.pause();
        this.audioPlaying = false;
      }

      if (this.myAudioCollect != null && !this.myAudioCollect.paused) {
        this.myAudioCollect.pause();
        this.myAudioCollect.currentTime = 0;
      }

      if (this.myAudioIncollect != null && !this.myAudioIncollect.paused) {
        this.myAudioIncollect.pause();
        this.myAudioIncollect.currentTime = 0;
      }
    },
    nounString: function(str) {
      var nounList = ["-", ".", ",", "〜"];
      var newStr = "";

      for (var i = 0; i < str.length; i++) {
        var c = str.charAt(i);
        if (nounList.indexOf(c) == -1) {
          newStr += c;
        }
      }

      return newStr.trim();
    },
    /*
     * Runmode用スライダー初期化
     */
    sliderInit: function() {
      this.swiperOut = new Swiper(".swiper-container1", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
      this.swiperIn = new Swiper(".swiper-container2", {
        direction: "horizontal",
        spaceBetween: 0,
        nested: true,
        centeredSlides: true,
        slidesPerView: "auto",
        initialSlide: 0
      });
    },

    /**
     * templateのindexからpathstep.actsのindexを取得する(T系レイアウト用)
     *
     * @param {int} index  templateのactsのindex
     * @param {int} index2 templateのactblockのindex
     */
    getTargetActTypeTyping: function(index, index2) {
      var count = 0;

      for (var i = 0; i < index; i++) {
        count += this.acts[i].length;
      }
      count += index2;

      return count;
    },
    /**
     * Actのテキスト入力可否を判定する(T系レイアウト用)
     *
     * @param {Object} act 現在出題中のact
     *
     * @return {Boolean} true: 入力可, false: 入力不可
     */
    isShowTextArea: function(act) {
      // 出題対象外の場合はテキスト入力不可
      if (!this.isChallenge(act)) {
        return false;
      }

      // 全解答または日本語翻訳表示中はテキスト入力不可
      if (this.dispAllAnswerStatus || this.dispJapaneseStatus) {
        return false;
      }

      // 上記以外はテキスト入力可
      return true;
    },
    /**
     * 入力テキストエリアの要素を取得する(T系レイアウト用)
     *
     * @return {Object} 取得したDOM要素
     */
    getInputTextElement: function() {
      var id = "inputtext";
      // モバイル版はActの要素のためidにindexを付与
      if (!this.isEnvironmentPc()) {
        id += this.currentActIndex;
      }
      return document.getElementById(id);
    },
    /**
     * 解答ボタンの要素を取得する(T系レイアウト用)
     *
     * @return {Object} 取得したDOM要素
     */
    getOkButtonElement: function() {
      var id = "okbutton";
      // モバイル版はActの要素のためidにindexを付与
      if (!this.isEnvironmentPc()) {
        id += this.currentActIndex;
      }
      return document.getElementById(id);
    },
    /**
     * スキップボタンの要素を取得する(T系レイアウト用)
     *
     * @return {Object} 取得したDOM要素
     */
    getSkipButtonElement: function() {
      var id = "ssbutton";
      // モバイル版はActの要素のためidにindexを付与
      if (!this.isEnvironmentPc()) {
        id += this.currentActIndex;
      }
      return document.getElementById(id);
    },
    /**
     * 解答テキストエリアの要素を取得する(T系レイアウト用)
     *
     * @return {Object} 取得したDOM要素
     */
    getAnswerStringElement: function() {
      var id = "answer_string";
      // モバイル版はActの要素のためidにindexを付与
      if (!this.isEnvironmentPc()) {
        id += this.currentActIndex;
      }
      return document.getElementById(id);
    },
    /**
     * 適用するfontクラスを取得する（T系レイアウト用）
     * ※T系Runmodeは他のRunmodeとカード部分の大きさが異なるので独自で判定
     *
     * @param {String} text 判定対象のテキスト
     *
     * @return {String} 適用するfontクラス名
     */
    getTextFontClassTypeTyping: function(text) {
      this.log("runmode start getTextFontClassTypeTyping text: " + text);

      var fontClass = "";
      var textLength = this.getTextSize(text);

      if (textLength < 0) {
        fontClass = "";
      } else if (textLength <= 34) {
        fontClass = mixinConstants.FONT_CLASS_28;
      } else if (textLength <= 47) {
        fontClass = mixinConstants.FONT_CLASS_24;
      } else if (textLength <= 63) {
        fontClass = mixinConstants.FONT_CLASS_21;
      } else if (textLength <= 101) {
        fontClass = mixinConstants.FONT_CLASS_18;
      } else if (textLength <= 123) {
        fontClass = mixinConstants.FONT_CLASS_15;
      } else {
        fontClass = mixinConstants.FONT_CLASS_14;
      }

      this.log("runmode end getTextFontClassTypeTyping returnValue: " + fontClass);
      return fontClass;
    },
    /**
     * テキストサイズを取得する
     */
    getTextSize: function(text) {
      this.log("runmode start getTextSize");
      var textLength = 0;

      if (!text) {
        textLength = -1;
        this.log("runmode end getTextSize text is none returnValue: " + textLength);
        return textLength;
      }

      // htmlタグを除去
      var replaceText = text.replace(/<.+?>/g, "");
      this.log("runmode getTextSize replaceText: " + replaceText);
      // 全角は２文字、半角は１文字で加算する
      for (var i = 0; i < replaceText.length; i++) {
        var str = replaceText.substring(i, i + 1);
        var result = str.match(/^[^\x01-\x7E\xA1-\xDF]+$/) ? true : false;
        if (result) {
          textLength += 2;
        } else {
          textLength += 1;
        }
      }
      this.log("runmode end getTextSize returnValue: " + textLength);
      return textLength;
    },
    /**
     * 対象の要素にフォントクラスを設定するかを確認し、値を設定する(T系レイアウト用)
     *
     * @param {Object} targetEle 設定対象の要素
     * @param {String} text 対象要素に設定されているテキスト
     *
     */
    checkSetTargetFontClassTypeTyping: function(targetEle, text) {
      // PC版はfontクラスを適用していないので処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      var trueFont = this.getTextFontClassTypeTyping(text);
      var applyFont = this.getTargetFontClass(targetEle);

      if (!trueFont) {
        return;
      }

      if (!applyFont) {
        // fontクラスが設定されていない場合は追加する
        targetEle.classList.add(trueFont);
      } else if (trueFont !== applyFont) {
        // 適用中のfontクラスの値が正しくないので付け替える
        targetEle.classList.remove(applyFont);
        targetEle.classList.add(trueFont);
      }
    },
    /**
     * 対象の要素からfontクラスを取得する
     *
     * @param {Object} targetEle 取得対象の要素
     *
     * @param {String} 要素から取得したfontクラス名(fontクラスがない場合はnull)
     */
    getTargetFontClass: function(targetEle) {
      this.log("runmode start getTargetFontClass");

      var targetClassList = targetEle.classList;

      for (var i = 0; i < targetClassList.length; i++) {
        var className = targetClassList[i];
        if (className.match("font")) {
          this.log("runmode end getTargetFontClass returnValue: " + className);
          return className;
        }
      }

      this.log("runmode end getTargetFontClass fontClass is none");
      return null;
    },
    /**
     * 単語毎にポップアップ辞書イベントを登録した要素の文字列を返却する
     *
     * @param {String} ポップアップ辞書イベントを登録する文字列
     * @return 単語毎にポップアップ辞書イベントを登録した要素の文字列
     */
    getPopupTextElem: function(text) {
      // ポップアップ辞書を表示しない場合は処理終了(引数をそのまま返却する)
      if (popupDictionary.settings.popup === DIC_OPTIONS_DISABLED || !text) {
        return text;
      }
      var popupText = "";
      var isTag = false;
      var endTagCount = 0;
      var word = "";
      var wordList = [];
      
      // 1文字毎に分割
      // （空白毎に分割した文字列の配列を取得する）
      // ※タグ内の空白は無視してタグの場合は開始タグから終了タグまで文字列結合する
      for (var chara of text) {
        word += chara;
        // 開始タグから終了タグまで文字列結合するためフラグを立てる
        if (chara === "<") {
          isTag = true;
        }
        if (chara === ">") {
          endTagCount += 1;
        }
        // 終了タグに達したらフラグを元に戻す
        if (endTagCount >= 2) {
          isTag = false;
          endTagCount = 0;
        }
        // タグ内ではなく空白だったら、次の単語を取得するためwordListに追加する
        if (!isTag && chara === " ") {
          wordList.push(word);
          word = "";
        }
      }
      // 最後の単語をwordListに追加する
      wordList.push(word);
      // 各単語毎にポップアップ辞書のイベントを付与する
      for (var word of wordList) {
        popupText += [
          "<span onmousemove='popupDictionary.popupMouseOver(event, this)'",
          "onmouseleave='popupDictionary.closeMouseOut()'",
          "onmouseup='popupDictionary.popupSelectedText(event)'",
          "onmousedown='popupDictionary.closeMouseClick()'>",
          word,
          "</span>"
        ].join(" ");
      }
      return popupText;
    },
    /**
     * 現在のpathstepからChallengeのactを取得する
     *
     * @return {Array} Challengeのactのリスト
     */
    getChallengeQuestions: function() {
      this.log("runmode start getChallengeQuestions");
      const self = this;
      return this.pathstep.acts.filter(function(act) {
        return self.isChallenge(act);
      });
    },
    /**
     * 指定されたjQuery要素の行数を取得する
     *
     * @param {Object} targetElem jQuery要素
     *
     * @return {Number} 行数
     */
    getLineNumber: function(targetElem) {
      this.log("runmode start getLineNumber");
      let lineHeight = parseFloat(targetElem.css("line-height"));
      let elemHeight = targetElem.height();
      let result = elemHeight / lineHeight;
      this.log("line number : " + result);
      return result;
    },
    /**
     * 指定されたフォントサイズから補正したフォントサイズを取得する
     *
     * @param {Number} 補正対象フォントサイズ
     *
     * @return {Number} 補正済みフォントサイズ
     */
    getCorrectionFontSize: function(fontSize) {
      const AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize];
      if (AUTO_ADJUST_FONT_SIZE.max <= fontSize) {
        return AUTO_ADJUST_FONT_SIZE.max;
      } else if (AUTO_ADJUST_FONT_SIZE.mid <= fontSize && fontSize < AUTO_ADJUST_FONT_SIZE.max) {
        return AUTO_ADJUST_FONT_SIZE.mid;
      } else {
        return AUTO_ADJUST_FONT_SIZE.min;
      }
    },
    /**
     * 画像拡大表示
     *
     * @param {String} imagePath 拡大表示対象の画像Path
     */
    showPinchInImage: function(imagePath) {
      this.log("runmode start showPinchIn imagePath: " + imagePath);
      // imagePathがない場合は非表示
      if(!imagePath) {
        return;
      }
      var pinchInParams = this.getPinchInParams(imagePath);
      this.$store.dispatch("setShowPinchIn", true);
      this.$store.dispatch("setPinchInParams", pinchInParams);
      this.$store.dispatch("setLessonState", constants.LESSON_STATE_PAUSE);
    },
    /**
     * 拡大表示データ取得
     * 引数のデータをオブジェクトにして返却する
     *
     * @param {String} imagePath 拡大表示対象の画像Path
     * @return {Object} 拡大表示データ
     *
     */
    getPinchInParams: function(imagePath) {
      var pinchInParams = {
        pinchInImagePath: imagePath
      };
      return pinchInParams;
    },
    /**
     * 自動調整されたフォントサイズを取得する
     *
     * @param {Object} targetFrame 対象テキスト表示領域
     * @param {Object} targetText 対象テキスト
     * @param {Number} fixedFontSize フォントサイズ
     *
     * @return {Number} 自動調整されたフォントサイズ
     */
    getAutoAdjustFontSize: function(targetFrame, targetText, fixedFontSize) {

      let result = fixedFontSize;

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return result;
      }

      // 行数を判定
      if (mixinConstants.MAX_LINE_NUMBER < this.getLineNumber(targetText)) {
        // 最大行数を超えていた場合、要素の高さを最大行数が収まる高さにする
        let lineHeight = parseFloat(targetText.css("line-height"));
        targetFrame.height(lineHeight * mixinConstants.MAX_LINE_NUMBER);

        // テキストが収まるように自動調整
        const AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize];
        targetFrame.textfill({
          minFontPixels: AUTO_ADJUST_FONT_SIZE.min,
          maxFontPixels: AUTO_ADJUST_FONT_SIZE.max,
          allowOverflow: true
        });
      }

      // フォントサイズを確定させる
      let textFontSize = parseInt(targetText.css("font-size"), 10);
      if (textFontSize < fixedFontSize) {
        result = this.getCorrectionFontSize(textFontSize);
      }

      // 確定したサイズを返す
      return result;
    },
    /**
     * 自動調整された高さを取得する
     *
     * @param {Object} targetFrame 対象テキスト表示領域
     * @param {Object} targetText 対象テキスト
     * @param {Number} fixedHeight 対象テキスト表示領域の現在の高さ
     * @param {Number} fixedFontSize 対象テキストの現在のフォントサイズ
     *
     * @return {Number} 自動調整された高さ
     */
    getAutoAdjustHeight: function(targetFrame, targetText, fixedHeight, fixedFontSize) {

      let result = fixedHeight;

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return result;
      }

      // 確定したフォントサイズを設定
      targetText.css({ fontSize: fixedFontSize });

      // カードの高さを確定させる
      let textAreaHeight = targetFrame.height();
      if (fixedHeight < textAreaHeight) {
        result = textAreaHeight;
      }

      // 確定したサイズを返す
      return result;
    },
    /**
     * カード領域のサイズを確定する
     * ~~~
     * 以下の理由でTileとNR系では使用できない
     * ・Tileはpathstep.actsを元に調整ができないため
     * ・NR系はheightの調整方法が異なるため
     * ~~~
     *
     * @param {Function} cloneCard 複製関数ポインタ
     * @param {Object} clones 複製する要素のポインタ
     */
    fixCardAreaSize: function(cloneCard, clones) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // カードのフォントサイズを求める
      for (let act of this.pathstep.acts) {
        // 英語で実施
        cloneCard(act.basicText);
        this.usCardAreaFontSize = this.getAutoAdjustFontSize(clones.textArea, clones.text, this.usCardAreaFontSize);
        clones.card.remove();
        // 日本語で実施
        cloneCard(act.japaneseText);
        this.jpCardAreaFontSize = this.getAutoAdjustFontSize(clones.textArea, clones.text, this.jpCardAreaFontSize);
        clones.card.remove();
      }

      // カードの高さを求める
      for (let act of this.pathstep.acts) {
        // 英語で実施
        cloneCard(act.basicText);
        this.usCardAreaHeight = this.getAutoAdjustHeight(clones.textArea, clones.text, this.usCardAreaHeight, this.usCardAreaFontSize);
        clones.card.remove();
        // 日本語で実施
        cloneCard(act.japaneseText);
        this.jpCardAreaHeight = this.getAutoAdjustHeight(clones.textArea, clones.text, this.jpCardAreaHeight, this.jpCardAreaFontSize);
        clones.card.remove();
      }
    },
    /**
     * 自動調整で確定したサイズを取得する
     *
     * @return {Object} 自動調整で確定したサイズ情報
     */
    getAutoAdjustFixedSize: function() {
      let result = {};

      if (this.dispJapaneseStatus) {
        // 日本語表示
        result.topAreaHeight = this.jpTopAreaHeight;
        result.topAreaFontSize = this.jpTopAreaFontSize;
        result.cardAreaHeight = this.jpCardAreaHeight;
        result.cardAreaFontSize = this.jpCardAreaFontSize;
      } else {
        // 英語表示
        result.topAreaHeight = this.usTopAreaHeight;
        result.topAreaFontSize = this.usTopAreaFontSize;
        result.cardAreaHeight = this.usCardAreaHeight;
        result.cardAreaFontSize = this.usCardAreaFontSize;
      }

      return result;
    },
    /**
     * 自動調整初期処理
     *
     * @param {Array} fontSelectors フォントサイズ初期化対象のセレクタ
     * @param {Array} invisibleSelectors 非表示対象のセレクタ
     */
    initAutoAdjust: function(fontSelectors, invisibleSelectors) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // フォントサイズを初期化
      for (let fontSelector of fontSelectors) {
        $(fontSelector).css({ fontSize: mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize].max });
      }
      // 自動調整処理中は非表示
      for (let invisibleSelector of invisibleSelectors) {
        $(invisibleSelector).css({ opacity: 0 });
      }
    },
    /**
     * 自動調整での最初の表示処理
     *
     * @param {Array} autoAdjustFuncs 実行する関数ポインタ
     * @param {Array} visibleSelectors 表示する要素のセレクタ
     */
    autoAdjustFirstShown: function(autoAdjustFuncs, visibleSelectors) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 自動調整済みの場合は処理終了
      if (this.isAutoAdjustShown) {
        return;
      }

      // 表示領域自動調整
      for (let autoAdjustFunc of autoAdjustFuncs) {
        autoAdjustFunc();
      }
      for (let visibleSelector of visibleSelectors) {
        $(visibleSelector).animate({ opacity: 1 }, 500);
      }
      this.isAutoAdjustShown = true;
    },
    /**
     * P系カード領域自動サイズ調整処理
     */
    autoAdjustParrotCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.textArea = clones.card.children("p");
        clones.textArea.empty().append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // サイズを確定させる
      this.fixCardAreaSize(cloneCard, clones);
    },
    /**
     * P系カード領域サイズ適用
     */
    applyParrotCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;

      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });

      // 音声テキスト表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $(".toparea-mic").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    },
    /**
     * P系自動調整初期処理
     */
    initAutoAdjustParrot: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 自動調整初期処理
      this.initAutoAdjust([".card-inner > .swiper-container > .swiper-wrapper > .item > p"], [".page-content"]);
    },
    /**
     * P系自動調整での最初の表示処理
     */
    autoAdjustFirstShownParrot: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustParrotCardArea, this.applyParrotCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * T系カード領域自動サイズ調整処理
     */
    autoAdjustTypingCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.card.children(".textarea-wrap").remove();
        clones.textArea = clones.card.children("p");
        clones.textArea.css({ display: "block" });
        clones.textArea.children("span").remove();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.textArea.css("cssText", "height: auto;");
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // サイズを確定させる
      this.fixCardAreaSize(cloneCard, clones);
    },
    /**
     * T系カード領域サイズ設定
     */
    applyTypingCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;

      // 確定した高さとフォントサイズを設定
      let itemArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item");
      let textAreaWrap = itemArea.children(".textarea-wrap");
      textAreaWrap.height(fixedHeight + mixinConstants.TYPING_TEXT_AREA_ADJUST_HEIGHT);
      textAreaWrap.children("textarea").height(fixedHeight);
      textAreaWrap.children(".answer").height(fixedHeight);
      textAreaWrap.children(".icon-wrap").height(fixedHeight);
      itemArea.children("p").height(fixedHeight);
      itemArea.css({ fontSize: fixedFontSize });
      this.placeholderFontSize = fixedFontSize;

      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $("#toparea").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    },
    /**
     * T系自動調整初期処理
     */
    initAutoAdjustTyping: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // テキスト表示領域の高さを初期化
      this.usCardAreaHeight = mixinConstants.MIN_TYPING_TEXT_AREA_HEIGHT;
      this.jpCardAreaHeight = mixinConstants.MIN_TYPING_TEXT_AREA_HEIGHT;

      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".page-content"]);
    },
    /**
     * T系自動調整での最初の表示処理
     */
    autoAdjustFirstShownTyping: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustTypingCardArea, this.applyTypingCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * 指定されたjQueryセレクタの正確な高さを取得する
     * ~~~
     * jQuery(1.x.x)のouterHeightだと小数点以下含む正確な値が取得できず
     * 端末によってはレイアウトが崩れるためgetComputedStyleで高さを取得する
     * ~~~
     *
     * @param {String} selector 対象のセレクタ
     *
     * @return {Number} 指定されたjQueryセレクタの高さ
     */
    getComputedStyleHeight: function(selector) {
      return parseFloat(getComputedStyle($(selector).get(0), "").height);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/runmode.js